import handleProviderProvider from 'mn-utils/changeProviderProviderSimple';
import find from 'mn-utils/find';
import trim from 'mn-utils/trim';
import Popup from '../../../dumb/Popup/C';
import TextField from '../../../dumb/TextField/H';
import {
  CRYPTOCOINS,
  CURRENCY_ITEMS,
  STABLECOINS,
} from '../../../../constants';
import {
  openPopupWindow,
  openV1PopupInfo,
} from '../../../../emitters/popup';
import changeProviderProvider from 'mn-utils/changeProviderProvider';
import Ripple from '../../../dumb/Ripple';
import AddIcon from '../../../icons/Plus';
import withReDelay from 'mn-utils/withReDelay';
import React from 'react';
import RefreshIcon from '@material-ui/icons/Refresh';
import Caption from '../../../dumb/Caption/A';
import HeaderA from '../../../dumb/Header/A';
import ButtonUp from '../../../dumb/Button/Up';
import Tooltip from '../../../dumb/Tooltip/A';
import RowA from '../../../dumb/Row/A';
import ColA from '../../../dumb/Col/A';
import ColA2 from '../../../dumb/Col/A2';
import RowB from '../../../dumb/Row/B';
import ColB from '../../../dumb/Col/B';
import ColB2 from '../../../dumb/Col/B2';
import WrapperWithLoading from '../../../dumb/WrapperWithLoading';
import ButtonD from '../../../dumb/Button/D';
import virtualOutputComponentProvider from '../../../../utils/virtualOutputComponentProvider';
import {
  apiAdminFineryPositions,
  apiAdminFinerySettlementCreate,
} from '../../../../api/admin/finery';
const {commit, emit} = require('./emitter');

const {
  DisplayIdAdmin,
  DisplayDataAdmin,
  DisplayAmountAdmin,
} = require("../../../dumb/DisplayData");

const COMPONENT_NAME = 'PositionTable';
module.exports = virtualOutputComponentProvider({
  rowHeight: 70,
  request: apiAdminFineryPositions,
  wrapper(render, setState, self) {
    const update = withReDelay(self.update, 100);
    commit(COMPONENT_NAME, update);

    const allCryptoCoins = [...CRYPTOCOINS, ...STABLECOINS, {id: 'BUSD'}, {id: 'USDC'}];
    const CRYPTO_ITEMS = allCryptoCoins.reduce((acc, item) => {
      acc.push({id: item.id});
      return acc;
    }, []);
    const ASSETS = [
      ...CURRENCY_ITEMS,
      {id: '------', disabled: true},
      ...CRYPTO_ITEMS,
    ];

    const openCreateSettlementWindow = (position) => {
      openPopupWindow((setPopupState, popup) => {
        const {close} = popup;
        const counterparty = position.counterparty || {};
        popup.state = {
          clicked: false,
          counterpartyName: counterparty.name,
          counterpartyId: counterparty.id,
          amount: position.amount,
          assetCode: position.asset_code,
          fee: position.fee || null,
          comment: '',
        };

        const asset = find(ASSETS, (asset) => asset.id === position.asset_code) || {};

        const handleProvider = changeProviderProvider(setPopupState);
        const changeProvider = handleProviderProvider(setPopupState);

        // const handleChangeCounterpartyName = handleProvider('counterpartyName');
        // const handleChangeAssetCode = changeProvider('assetCode');
        const handleChangeAmount = handleProvider('amount');
        const handleChangeFee = handleProvider('fee');
        const handleChangeComment = handleProvider('comment');

        return (stateOfPopup) => {
          let {
            counterpartyId,
            counterpartyName,
            amount,
            assetCode,
            comment,
            fee,
          } = stateOfPopup;
          amount = Math.abs(amount);

          const invalidCounterpartyName = !trim(counterpartyName);
          const invalidAmount = !(amount > 0 && amount <= Math.abs(position.amount));
          const invalidFee = fee < 0 || amount + +fee > Math.abs(position.amount);
          const invalidAssetCode = !find(ASSETS, (asset) => asset.id === assetCode);
          const isErrors = invalidCounterpartyName || invalidAmount || invalidAssetCode || invalidFee;

          const maxAmount = Math.abs(position.amount);

          const maxAmountIsSet = maxAmount === amount;

          return (
            <Popup caption={(
              <div className="layoutRow fhaS fvaC w">
                <div>Add a new Deposit</div>
              </div>
            )}
            onCancel={close}
            disabled={stateOfPopup.clicked && isErrors}
            onSave={() => {
              if (isErrors) {
                setPopupState({
                  clicked: true,
                });
                return;
              }

              setPopupState({
                loading: true,
              });

              const params = {
                counterparty_id: counterpartyId,
                amount: amount,
                currency: assetCode,
                comment: comment,
                ...(fee > 0 ? {fee: fee} : {}),
              };

              apiAdminFinerySettlementCreate(params).finally((error) => {
                setPopupState({
                  loading: false,
                });

                if (error) {
                  return;
                }
                emit('SettlementTable');
                emit('PositionTable');
                openV1PopupInfo(['Success', 'Deposit created successfully!']);
                close();
              });
            }}
            >
              <WrapperWithLoading loading={stateOfPopup.loading}>
                <TextField
                  className="mt20 wmax472 mr10>1"
                  label="Counterparty name"
                  value={counterpartyName}
                  // onChange={handleChangeCounterpartyName}
                  error={stateOfPopup.clicked && invalidCounterpartyName}
                  disabled
                />
                <TextField
                  className="mt20 wmax472 mr10>1"
                  label="Asset code"
                  value={asset.id}
                  // onChange={handleChangeAssetCode}
                  error={stateOfPopup.clicked && invalidAssetCode}
                  disabled
                />
                {/*<Select3*/}
                {/*  className="mt20 wmax472 mr10>1"*/}
                {/*  label="Asset code"*/}
                {/*  propName="id"*/}
                {/*  propValue="id"*/}
                {/*  value={assetCode}*/}
                {/*  // onChange={handleChangeAssetCode}*/}
                {/*  items={ASSETS}*/}
                {/*  error={stateOfPopup.clicked && invalidAssetCode}*/}
                {/*  disabled*/}
                {/*/>*/}
                <TextField
                  className="mt20 wmax472 mr10>1"
                  label="Amount"
                  value={amount}
                  onChange={handleChangeAmount}
                  error={stateOfPopup.clicked && invalidAmount}
                  helperText={`The amount must be between 0 and ${maxAmount} exceed`}
                  description={`Maximum amount is ${maxAmount} ${asset.id}`}
                />
                <TextField
                  className="mt20 wmax472 mr10>1"
                  label="Fee"
                  value={maxAmountIsSet ? 0 : fee}
                  onChange={handleChangeFee}
                  error={stateOfPopup.clicked && invalidFee}
                  helperText={`Must not exceed ${Math.abs(position.amount) - amount} ${assetCode}`}
                  description={
                    maxAmountIsSet
                      ? `You can't change fee while amount is max`
                      : `Maximum fee is ${maxAmount - amount} ${asset.id}`
                  }
                  disabled={maxAmountIsSet}
                />
                <TextField
                  multiline
                  className="mt20 wmax472 mr10>1"
                  label="Comment"
                  value={comment}
                  onChange={handleChangeComment}
                  maxLength={192}
                  displayMaxLength
                />
              </WrapperWithLoading>
            </Popup>
          );
        };
      });
    };

    function Item({data}) {
      const counterparty = data.counterparty || {};
      const id = counterparty.id || '';
      const name = counterparty.name || '';
      const currency = data.asset_code || '';
      const amount = data.amount || 0;

      return (
        <RowA className="f12">
          <ColA className="wmin155 fx1">
            <DisplayIdAdmin>{id}</DisplayIdAdmin>
          </ColA>
          <ColA className="wmin200 fx1">
            <DisplayDataAdmin>{name}</DisplayDataAdmin>
          </ColA>
          <ColA className="wmin200 fx1">
            <DisplayAmountAdmin
              amount={amount}
              symbol={currency}
              type="coin"
            />
          </ColA>
          <ColA2 className="w50">
            <Tooltip title="Create deposit" disabledCopy>
              <Ripple
                className="wsNW dF aiC h42 pv7 ph10 r7 bgc0.25 (bgc0.5):h"
                onClick={() => {
                  openCreateSettlementWindow(data);
                }}
              >
                <AddIcon className="w20 h20"/>
              </Ripple>
            </Tooltip>
          </ColA2>
        </RowA>
      );
    }

    return (state, props) => {
      return (
        <div className={props.className || ''}>
          <HeaderA>
            <Caption>Positions</Caption>

            <WrapperWithLoading loading={state.loading}>
              <div className="layoutRow fhaS fvaC">
                <ButtonD className="wmin100" onClick={update}>
                  <RefreshIcon/>
                  <div className="pl15">Refresh</div>
                </ButtonD>
              </div>
            </WrapperWithLoading>
          </HeaderA>

          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45">
              <div className="wmin650 rlv h">
                <RowB className="f12 h66">
                  <ColB className="wmin200 fx1">CP ID</ColB>
                  <ColB className="wmin200 fx1">CP Name</ColB>
                  <ColB className="wmin200 fx1">Amount</ColB>
                  <ColB2 className="w50 tc"/>
                </RowB>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp show={state.showUp} onClick={self.handleToUp}/>
          </div>
        </div>
      );
    };
  },
});
